import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconFillAlertTriangle = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--fill-alert-triangle")} iconColor={color} size={size} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fillRule="evenodd" clipRule="evenodd" d="M9.53204 2.58561C10.0574 1.59921 10.9919 1 11.9995 1C13.0072 1 13.9417 1.59921 14.467 2.58561L22.6137 18.0752C23.1259 19.0855 23.1289 20.3293 22.6217 21.3428C22.1145 22.3563 21.1732 22.9871 20.1384 23L3.85008 22.9999C2.82587 22.9871 1.88455 22.3563 1.37732 21.3428C0.8701 20.3293 0.873158 19.0855 1.39316 18.0601L9.53204 2.58561ZM11 9.33333V14.6667C11 15.403 11.4477 16 12 16C12.5523 16 13 15.403 13 14.6667V9.33333C13 8.59695 12.5523 8 12 8C11.4477 8 11 8.59695 11 9.33333ZM12.7071 17.2929C13.0976 17.6834 13.0976 18.3166 12.7071 18.7071C12.3166 19.0976 11.6834 19.0976 11.2929 18.7071C10.9024 18.3166 10.9024 17.6834 11.2929 17.2929C11.6834 16.9024 12.3166 16.9024 12.7071 17.2929Z" fill="currentColor"/>
  </IconWrapper>
)
